import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.model("StringCompareTerminal", "ExpressionTerminal", {
    defaults: {
      relop: "=",
      value: ""
    },

    initialize: function() {
      this.on('change:value', function() {
        if (this.previousAttributes().value === "" && this.get('value') !== "" && this.get('relop') !== 'contains') {
          this._triggerValidations();
        }
      });

      this.on('change:relop', function() {
        if (this.get('relop') === "present") {
          this._triggerValidations();
        }
      });
    },

    beforeSet: function(attributes) {
      if (attributes.relop === '==') {
        attributes = _.extend({}, attributes, { relop: '=' });
      }
      if (attributes.relop === "present") {
        attributes = _.extend({}, attributes, { value: '' });
      }

      return attributes;
    },

    type: function() {
      return 'StringCompare';
    },

    validate: function() {
      var errors = [];

      if (this._shouldAddValueErrors()) { errors.push(this._valueError()); }

      if (!_.isEmpty(errors)) { return errors; }
    },

    text: function() {
      return (
        _.compact([
          this._textPrefix(),
          this.get('relop'),
          this._valueDisplay()
        ]).join(" ")
      );
    },

    shouldDisplayValue: function() {
      return this.get('relop') !== "present";
    },

    _textPrefix: function() {
      return this.get('terminal');
    },

    _valueDisplay: function() {
      if (this.shouldDisplayValue()) {
        return '"' + this.get('value') + '"';
      }
    },

    _shouldAddValueErrors: function() {
      return this.get('relop') !== 'present' && (this.get("value") === "" || this.get("value") === undefined);
    },

    _valueError: function() {
      return this.get("terminal") + " cannot be empty";
    },

    _triggerValidations: function() {
      if (this.isValid()) { this.trigger('validate'); }
    }
  });
});
